import React, { useState, useEffect, ReactNode } from 'react'
import { flashMessageContext } from '../../contexts'

interface FlashMessageProviderProps {
  children: ReactNode
  value?: string
}

function FlashMessageProvider({ children, value }: FlashMessageProviderProps) {
  // Check for flash message in query string
  const getFlashMessageFromQuery = () => {
    const params = new URLSearchParams(window.location.search)
    const flashMessageParam = params.get('flash_message') || params.get('flashMessage')
    const errorParam = params.get('error_message') || params.get('errorMessage')
    
    if (flashMessageParam) {
      return {
        message: flashMessageParam,
        isError: false,
      }
    } else if (errorParam) {
      return {
        message: errorParam,
        isError: true,
      }
    }
    return null
  }

  /**
   * Shape of this object should be
   * { message: string, isError: boolean }
   * when set
   */
  const [flashMessage, setFlashMessage] = useState(
    value
      ? {
          message: value,
          isError: false,
        }
      : getFlashMessageFromQuery()
  )

  // Clean up query string after reading flash message
  useEffect(() => {
    const params = new URLSearchParams(window.location.search)
    if (params.has('flash_message') || params.has('flashMessage') || 
        params.has('error_message') || params.has('errorMessage')) {
      params.delete('flash_message')
      params.delete('flashMessage')
      params.delete('error_message')
      params.delete('errorMessage')
      const newSearch = params.toString()
      const newUrl = window.location.pathname + (newSearch ? `?${newSearch}` : '')
      window.history.replaceState({}, '', newUrl)
    }
  }, [])

  return (
    <flashMessageContext.Provider value={[flashMessage, setFlashMessage]}>
      {children}
    </flashMessageContext.Provider>
  )
}


export default FlashMessageProvider